import React, { useState } from "react";
import axios from "axios";
import "../forms-styles/FormStyles.css";

const CreatorApply = () => {
  const [username, setUsername] = useState("");
  const [realName, setRealName] = useState("");
  const [age, setAge] = useState("");
  const [experience, setExperience] = useState("");
  const [whyJoin, setWhyJoin] = useState("");
  const [contentLinks, setContentLinks] = useState("");
  const [additionalInfo, setAdditionalInfo] = useState("");
  const [status, setStatus] = useState("");

  const webhookURL =
    "https://discord.com/api/webhooks/1375118126449950740/p6jFDDjELXLXG_xlOgO1qxuYpDp2UqO-qhr6fyvBOna5oKsLzWH53Bd_D7evvR0TLnQI";

  const isValidUrl = (url) => {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !username.trim() ||
      !realName.trim() ||
      !age.trim() ||
      !experience.trim() ||
      !whyJoin.trim() ||
      !contentLinks.trim()
    ) {
      return alert("Please fill in all required fields.");
    }

    // Validate age as a number between 13 and 100 (example)
    const ageNum = parseInt(age, 10);
    if (isNaN(ageNum) || ageNum < 13 || ageNum > 100) {
      return alert("Please enter a valid age (between 13 and 100).");
    }

    // Validate content links (comma-separated URLs)
    const links = contentLinks.split(",").map((l) => l.trim());
    for (const link of links) {
      if (!isValidUrl(link)) {
        return alert(`Invalid URL detected: ${link}`);
      }
    }

    setStatus("Submitting...");

    const embed = {
      title: "Creator Application",
      color: 3447003,
      fields: [
        { name: "Minecraft Username", value: username, inline: true },
        { name: "Real Name", value: realName, inline: true },
        { name: "Age", value: age, inline: true },
        { name: "Experience", value: experience },
        { name: "Why do you want to join?", value: whyJoin },
        { name: "Content Links", value: links.join("\n") },
      ],
      timestamp: new Date(),
    };

    if (additionalInfo.trim()) {
      embed.fields.push({
        name: "Additional Information",
        value: additionalInfo,
      });
    }

    try {
      await axios.post(webhookURL, {
        content: `New Creator Application Submitted:`,
        embeds: [embed],
      });

      setStatus("✅ Application submitted successfully.");
      // Clear form
      setUsername("");
      setRealName("");
      setAge("");
      setExperience("");
      setWhyJoin("");
      setContentLinks("");
      setAdditionalInfo("");
    } catch (error) {
      console.error(error);
      setStatus("❌ Failed to submit. Please try again.");
    }
  };

  return (
    <div className="form-container">
      <h2>🎥 Creator Application</h2>
      <p className="form-note">
        Please fill out all required fields. Provide links to your content (YouTube, Twitch, etc.).
      </p>
      <form onSubmit={handleSubmit} className="form">
        <label>
          Minecraft Username <span className="required">*</span>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </label>

        <label>
          Real Name <span className="required">*</span>
          <input
            type="text"
            value={realName}
            onChange={(e) => setRealName(e.target.value)}
            required
          />
        </label>

        <label>
          Age <span className="required">*</span>
          <input
            type="number"
            min="13"
            max="100"
            value={age}
            onChange={(e) => setAge(e.target.value)}
            required
          />
        </label>

        <label>
          Experience <span className="required">*</span>
          <textarea
            rows="4"
            placeholder="Describe your experience as a creator or in Minecraft communities"
            value={experience}
            onChange={(e) => setExperience(e.target.value)}
            required
          />
        </label>

        <label>
          Why do you want to join? <span className="required">*</span>
          <textarea
            rows="3"
            placeholder="Tell us why you'd be a great addition"
            value={whyJoin}
            onChange={(e) => setWhyJoin(e.target.value)}
            required
          />
        </label>

        <label>
          Content Links (comma separated) <span className="required">*</span>
          <input
            type="text"
            placeholder="https://youtube.com/yourchannel, https://twitch.tv/yourchannel"
            value={contentLinks}
            onChange={(e) => setContentLinks(e.target.value)}
            required
          />
        </label>

        <label>
          Additional Information (optional)
          <textarea
            rows="3"
            placeholder="Anything else you'd like to share"
            value={additionalInfo}
            onChange={(e) => setAdditionalInfo(e.target.value)}
          />
        </label>

        <button type="submit" className="submit-button">
          📤 Submit Application
        </button>
        <p className="form-status">{status}</p>
      </form>
    </div>
  );
};

export default CreatorApply;
